// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementMessageStepsForUcoCanvasIdResult = objectOf({
  message_steps: arrayOf(objectOf({ id: string, name: string, composition_mode: string })),
});
